import './copy-button.less';
import { keycodesModule } from '../../constants/keycodes';
import * as EventUtils from '../../utils/event-utils';
import * as StringUtils from '../../utils/string-utils';
import { bubbleDialogComponentModule } from '../../components/bubble-dialog/bubble-dialog';
import { clipboardComponentModule } from '../../vendor/clipboard-component-module';

export const copyButtonComponentModule = angular
  .module('Q.components.copy-button', [
    keycodesModule,
    bubbleDialogComponentModule,
    clipboardComponentModule,
  ])

  /**
   * @ngdoc directive
   * @name copyButton
   * @description
   * Turns a button into a one-click text copy action
   * @element ANY
   * @restrict A
   *
   * @param {template} copyButtonLabel? Label text
   * @param {expression} copyButtonValue Value to be copied
   */
  .directive(
    'copyButton',
    function (
      clipboard,
      bubbleDialogService,
      $timeout,
      $sce,
      $window,
      KeyCodes,
    ) {
      return {
        restrict: 'A',
        link(scope, elem, attr) {
          elem.addClass('copy-button');
          elem.text(attr.copyButtonLabel);

          let successTimeout = null;

          function showSuccess() {
            if (successTimeout) {
              $timeout.cancel(successTimeout);
            }
            elem.addClass('copy-button-success');
            if (attr.copyButtonLabel) {
              elem.css({ 'min-width': elem.offsetWidth() + 'px' });
              elem.text('Copied!');
            }
            successTimeout = $timeout(
              () => {
                if (attr.copyButtonLabel) {
                  elem.css({ 'min-width': null });
                  elem.text(attr.copyButtonLabel);
                }
                elem.removeClass('copy-button-success');
                successTimeout = null;
              },
              2000,
              false,
            );
          }

          elem.on('click', function (event) {
            EventUtils.stopEvent(event);

            let value = attr.copyButtonValue
              ? scope.$eval(attr.copyButtonValue)
              : '';

            if (clipboard.supported) {
              try {
                clipboard.copyText(value);
                showSuccess();
                return;
              } catch (e) {
                // ignore copy errors, just show the pop-up
              }
            }

            let dialogContent = `\
<div>Press <span class="shortcut-hint">${KeyCodes.SYMBOLS.COMMAND_KEY} + C</span> to copy the text below:</div>
<div><input type="text" autofocus class="form-input" value="${StringUtils.escapeHTML(value)}"></div>`;

            let bubbleResult = bubbleDialogService.open(scope, elem, {
              title: attr.copyButtonLabel,
              content: $sce.trustAsHtml(dialogContent),
            });

            bubbleResult.result.then(null, null, (status) => {
              if (status.ready) {
                let el = status.element;
                let $in = el.find('input');
                if ($in.length) {
                  $in.focus().selectInput();
                  let inputEl = $in[0];
                  inputEl.selectionStart = 0;
                  inputEl.selectionEnd = inputEl.value.length;
                  $in.on('copy', () => {
                    showSuccess();
                    bubbleResult.close();
                  });
                }
              }
            });
          });
        },
      };
    },
  );
